import Vue from 'vue'
import App from './App.vue'
import vuetify from '@/plugins/vuetify'
import store from './store'
import router from './router'
import '@/plugins/portal'
import '@/plugins/pouchdb'
import './registerServiceWorker'

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app');